import type { PAGE_POSITIONS } from 'types';

import type { PostAuthOptions } from '../Modals/Login';
import Apple from './Apple';
import Facebook from './Facebook';
import Google from './Google';

export type Props = {
  onError: (err: string | null) => void;
  onSuccess?: () => void;
  pagePosition: PAGE_POSITIONS;
  postAuthOptions?: PostAuthOptions;
};

export default {
  Apple,
  Facebook,
  Google
};
